import { io } from 'socket.io-client';

function resolveSocketBaseUrl() {
  const raw = process.env.REACT_APP_API_BASE_URL;
  if (raw && String(raw).trim()) {
    return String(raw).replace(/\/$/, '');
  }
  return 'http://localhost:5555';
}

let socket = null;

export function connectDashboardSocket({ userId, userType, onNotification }) {
  disconnectDashboardSocket();

  const url = resolveSocketBaseUrl();
  socket = io(url, {
    transports: ['websocket', 'polling'],
    reconnection: true,
    reconnectionDelay: 1000,
    reconnectionAttempts: 10,
  });

  socket.on('connect', () => {
    if (userId && userType) {
      socket.emit('join', { userId, userType });
    }
  });

  socket.on('dashboard_notification', (payload) => {
    if (typeof onNotification === 'function') onNotification(payload);
  });

  socket.on('connect_error', (err) => {
    console.warn('[fleet dashboard socket]', err?.message || err);
  });

  return socket;
}

export function disconnectDashboardSocket() {
  if (!socket) return;
  try {
    socket.removeAllListeners();
    socket.disconnect();
  } catch {
    /* ignore */
  }
  socket = null;
}
